<template>
  <!-- 关联图片 -->
  <el-dialog
    :append-to-body="true"
    :title="imgType === 0 ? '上传主图' : '上传介绍图'"
    :visible.sync="associatedImagesVisible"
    width="800px"
    :before-close="closeAddImgDialog"
    class="img_dialog"
  >
    <div class="contents">
      <div class="img-choice">
        <p v-if="imgType == 0">
          注：您可以点击“上传主图”按钮进行本地图片的上传，也可以选择商品主图管理在文件目录查找您将要关联的图片。主图最多为5张图片，至少上传1张，支持JPG、JPEG、PNG格式，正方形图片，建议使用800*800px，单张大小不超过4M。
        </p>
        <p v-else>
          注：您可以点击“上传介绍图”按钮进行本地图片的上传，也可以选择商品介绍图管理在文件目录查找您将要关联的图片。介绍图最多为10张图片，至少上传1张，支持JPG、JPEG、PNG格式，建议使用宽度为800px的图片，单张大小不超过4M。
        </p>
      </div>
      <!-- 主图 -->
      <div v-show="showBtn" class="img-local">
        <div class="choice-img-wrap">
          <div
            v-for="item in defaultImgList"
            :key="item"
            class="default-img-wrap"
            :style="{ left: item * 100 + item * 20 + 'px' }"
          >
            <img src="@/assets/img/common/img-default@2x.png" />
          </div>
          <draggable
            :list="mainImgList"
            :disabled="!enabled"
            class="list-group"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              v-for="(item, index) in mainImgList"
              :key="index"
              class="images"
            >
              <!-- <viewer
                    :images="mainImgList"
                    :options="options"
                    ref="viewer"
                    class="viewer-group"
                  > -->
              <template>
                <img
                  v-viewer="{ toolbar: false, zIndex: 9999 }"
                  :src="item.url"
                  alt
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-draggable@2x.png"
                  alt
                  style="left: 20px"
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-preview@2x.png"
                  alt
                  style="left: 40px"
                  @click="show(item.url)"
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-delete.png"
                  alt
                  style="left: 60px"
                  @click="deleteMainImgList(item)"
                />
                <div v-if="index == 0" class="main-img-icon-wrap">
                  <img
                    class="icon-main"
                    src="../../../../../assets/img/product/icon-main.png"
                    alt
                  />
                  <span>商品主图</span>
                </div>

                <div class="mask"></div>
              </template>
              <!-- </viewer> -->
            </div>
          </draggable>
        </div>
        <div v-if="mainImgList.length < 5" class="img-item">
          <el-upload
            ref="mainImg"
            :action="uploadUrl"
            :on-success="handleImgSuccess"
            accept=".jpg, .png, .pdf, .jpeg"
            :before-upload="beforeUpload"
            :headers="headers"
            :file-list="fileList1"
            :on-remove="handleImgRemove"
            :show-file-list="false"
            :on-error="handleImgError"
            multiple
            :limit="mainImgLimit"
            :on-exceed="handleImgExceed"
          >
            <div class="upload-btn">
              <img
                src="../../../../../assets/img/product/icon-add-img@2x.png"
                alt
              />
              <div class="txt">添加上传图片</div>
            </div>
          </el-upload>
        </div>
        <!-- <span class="upload-txt">本地上传({{ mainImgList.length }}/5)</span> -->
      </div>
      <!-- 详情图 -->
      <div v-show="!showBtn" class="img-local">
        <div class="choice-img-wrap detail-img-wrap">
          <div
            v-if="detailImgList.length < 10"
            class="img-item"
            style="position: absolute"
            :style="{
              left:
                detailImgList.length * 100 + detailImgList.length * 20 + 'px',
            }"
          >
            <el-upload
              ref="detailImg"
              :action="uploadUrl"
              :on-success="handleDetailImgSuccess"
              :headers="headers"
              :file-list="fileList2"
              :on-remove="handleDetailImgRemove"
              :show-file-list="false"
              :before-upload="beforeUploadDetail"
              multiple
              :limit="detailImgLimit"
              :on-exceed="handleDetailImgExceed"
            >
              <div class="upload-btn">
                <img
                  src="../../../../../assets/img/product/icon-add-img@2x.png"
                  alt
                />
                <div class="txt">添加上传图片</div>
              </div>
            </el-upload>
          </div>
          <div
            v-for="item in defaultDetailImgList"
            :key="item"
            class="default-img-wrap"
            :style="{ left: item * 100 + item * 20 + 'px' }"
          >
            <img src="@/assets/img/common/img-default@2x.png" />
          </div>
          <draggable
            :list="detailImgList"
            :disabled="!enabled"
            class="list-group"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              v-for="(item, index) in detailImgList"
              :key="index"
              class="images"
            >
              <template>
                <img v-viewer="{ toolbar: false }" :src="item.url" alt />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-draggable@2x.png"
                  alt
                  style="left: 20px"
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-preview@2x.png"
                  alt
                  style="left: 40px"
                  @click="show(item.url)"
                />
                <img
                  class="icon-close pointer"
                  src="../../../../../assets/img/product/icon-delete.png"
                  alt
                  style="left: 60px"
                  @click="deleteDetailImgList(item)"
                />
                <div class="mask"></div>
              </template>
            </div>
          </draggable>
        </div>
        <!-- <div class="img-item">
            <el-upload
              :action="uploadUrl"
              :on-success="handleDetailImgSuccess"
              :headers="headers"
              ref="detailImg"
              :file-list="fileList2"
              :on-remove="handleDetailImgRemove"
              :show-file-list="false"
              :before-upload="beforeUploadDetail"
              multiple
              :limit="detailImgLimit"
              :on-exceed="handleDetailImgExceed"
            >
              <div class="upload-btn">
               <img
                  src="../../../../../assets/img/product/icon-add-img@2x.png"
                  alt
                />
                 <div class="txt">添加上传图片</div>
              </div>
            </el-upload>
          </div> -->
      </div>
      <div class="img-store-wrap">
        <div class="img-ope">
          <div class="ope">
            <!-- <span class="img-tree-wrap" @click.stop="showTree()">
              {{ imgType == 0 ? "商品主图管理" : "商品介绍图管理" }}
            </span> -->
            <div v-if="isShowTree" class="img-tree">
              <el-tree
                :props="defaultProps"
                :load="loadNode"
                lazy
                :highlight-current="true"
                @node-click="handleNodeClick"
              ></el-tree>
            </div>
          </div>
        </div>
        <div class="img-list">
          <div v-for="item in imgList" :key="item.fileId">
            <img
              class="pointer"
              :src="item.imgAbsolutePath"
              :alt="item.imgName"
              @click="selectImgFromLibray(item)"
            />
            <span
              :class="{
                active:
                  imgType == 0
                    ? imageUrlsExist.indexOf(item.imgAbsolutePath) != -1
                    : detailImageUrlsExist.indexOf(item.imgAbsolutePath) != -1,
              }"
            >
              <i
                v-if="
                  imgType == 0
                    ? imageUrlsExist.indexOf(item.imgAbsolutePath) != -1
                    : detailImageUrlsExist.indexOf(item.imgAbsolutePath) != -1
                "
                class="el-icon-check"
              ></i>
            </span>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <el-button v-show="showBtn" type="primary" @click="nextStep"
          >下一步关联介绍图</el-button
        >
        <el-button v-show="!showBtn" type="primary" @click="preStep"
          >返回关联主图</el-button
        >
        <el-button v-show="!showBtn" type="primary" @click="submitProductImg"
          >提交</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import draggable from 'vuedraggable';
import api from '../../../api/product';
import { epecToken } from '../../../utils/globalData';
import util from '../../../utils/utils';
import productUtils from '../../../utils/productUtils.js';

import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';

Vue.use(VueViewer);
VueViewer.setDefaults({
  toolbar: false,
});
export default {
  components: {
    draggable,
  },
  props: {
    associatedImagesVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultImgList: [1, 2, 3, 4], // 图片默认占位图
      defaultDetailImgList: [1, 2, 3, 4, 5, 6, 7, 8, 9], // 详情图默认占位图
      detailImgLimit: 10, // 详情图默认上传限制
      mainImgLimit: 5, // 主图默认上传限制
      enabled: true,

      headers: epecToken,
      fileList: [], // 主图文件列表
      detailFileList: [], // 详情图列表
      fileList1: [],
      fileList2: [],
      uploadUrl: api.fileUpload,
      isShowTree: false,
      defaultProps: {
        children: 'children',
        label: 'fileName',
      },
      imgType: 0,
      imgList: [], // 图片链接
      showBtn: true,
      // 详情图
      detailImageUrls: [],
      // 详情图库图
      detailImageUrlsExist: [],
      // 主图
      imageUrls: [],
      // 主图图库图
      imageUrlsExist: [],
      associatedImagesForm: {},
      showImgExist: [], // 展示主图列表
      showDetailImgExist: [], // 展示详情图列表

      mainImgList: [], // 主图回显列表
      detailImgList: [], // 详情图回显列表
    };
  },
  watch: {
    associatedImagesVisible(newVal) {
      if (newVal) {
        this.fileList = []; // 主图上传
        this.detailFileList = []; // 详情图上传
        this.imageUrlsExist = []; // 主图图库
        this.detailImageUrlsExist = []; // 详情图图库
      }
    },
  },
  methods: {
    initData() {
      this.mainImgList = [];
      this.detailImgList = [];
      this.imageUrlsExist = [];
      this.detailImageUrlsExist = [];
      this.imgType = 0;
      this.imgList = [];
      (this.defaultImgList = [1, 2, 3, 4]), // 图片默认占位图
        (this.defaultDetailImgList = [1, 2, 3, 4, 5, 6, 7, 8, 9]), // 详情图默认占位图
        this.showTree();
    },
    checkMove(e) {
      console.log(`Future index: ${e.draggedContext.futureIndex}`);
    },
    handleDetailImgExceed(files) {
      const total = files.length + this.detailImgList.length;
      if (total > 10) {
        this.$message.warning(`详情图不能超过10张`);
      }
    },
    handleImgExceed(files) {
      const total = files.length + this.mainImgList.length;
      if (total > 5) {
        this.$message.warning(`主图不能超过5张`);
      }
    },
    handleImgError(err) {
      console.log(err);
      this.$router.push({ path: '/ssologin' });
    },
    /* Cancel() {
      // this.dialogVisible = false;
      this.$refs.mainImg.clearFiles();
      this.$refs.detailImg.clearFiles();
      this.fileList.length = 0;
      this.mainImgList.length = 0;
      this.detailFileList.length = 0;
      this.imageUrlsExist.length = 0;
      this.detailImageUrlsExist.length = 0;
      console.log(this.fileList);
      console.log(this.mainImgList);
    }, */
    show(img) {
      console.log(img);
      this.$viewerApi({
        images: [img],
      });
    },
    // 主图成功
    handleImgSuccess(res, file) {
      console.log(res);
      console.log(file);
      this.fileList.push(res.data.url);
      this.mainImgList.push({
        url: res.data.url,
        type: 'upload',
      });
      this.defaultImgList.shift();
    },
    // 主图
    beforeUpload(file) {
      console.log(file);
      if (
        file.type != 'image/png' &&
        file.type != 'image/jpg' &&
        file.type != 'image/jpeg'
      ) {
        this.$message.warning('文件为JPG、JPEG、PNG格式');
        return false;
      }
      const size = file.size / 1024 / 1024;
      if (size > 4) {
        this.$message.warning('图片不能超过4M');
        return false;
      }

      const { length } = this.mainImgList;
      if (length >= 5) {
        this.$message.warning('主图不能超过5张');
        return false;
      }
    },
    // 主图移除
    handleImgRemove(file) {
      // console.log(file);
      // console.log(fileList);
      console.log(this.fileList1);
      const index = util.getArgumentIndexInAttr(
        this.fileList,
        'url',
        file.response.data.url
      );
      const mainListIndex = util.getArgumentIndexInAttr(
        this.mainImgList,
        'url',
        file.response.data.url
      );
      const fileList1Index = util.getArgumentIndexInAttr(
        this.fileList1,
        'url',
        file.response.data.url
      );
      this.fileList.splice(index, 1);
      this.mainImgList.splice(mainListIndex, 1);
      if (fileList1Index != -1) {
        this.fileList.splice(fileList1Index, 1);
      }
    },
    // 详情成功
    handleDetailImgSuccess(res) {
      this.detailFileList.push(res.data.url);
      this.detailImgList.push({
        url: res.data.url,
        type: 'upload',
      });
      this.defaultDetailImgList.shift();
    },
    // 详情移除
    handleDetailImgRemove(file) {
      const index = util.getArgumentIndexInAttr(
        this.detailFileList,
        'url',
        file.response.data.url
      );
      this.detailFileList.splice(index, 1);
    },
    // 详情
    beforeUploadDetail(file) {
      if (
        file.type != 'image/png' &&
        file.type != 'image/jpg' &&
        file.type != 'image/jpeg'
      ) {
        this.$message.warning('文件为JPG、JPEG、PNG格式');
        return false;
      }
      const size = file.size / 1024 / 1024;
      if (size > 4) {
        this.$message.warning('图片不能超过4M');
        return false;
      }
      const { length } = this.detailImgList;
      if (length >= 10) {
        this.$message.warning('介绍图不能超过10张');
        return false;
      }
    },

    closeAddImgDialog() {
      this.$emit('update:associatedImagesVisible', false);
      this.$refs.mainImg.clearFiles();
      this.$refs.detailImg.clearFiles();
      this.fileList.length = 0;
      this.mainImgList.length = 0;
      this.detailFileList.length = 0;
      this.imageUrlsExist.length = 0;
      this.detailImageUrlsExist.length = 0;
      console.log(this.fileList);
      console.log(this.mainImgList);
    },
    // 懒加载时触发
    async loadNode(node, resolve) {
      console.log(node);
      if (node.level === 0) {
        const params = {
          fileType: this.imgType,
          parentId: -1,
        };
        await this.getImgTreeFromLibrary(params);
        return resolve(this.treeData);
      }
      // if (node.level > 1) return resolve([]);
      if (node.level === 1) {
        // 二级节点
        this.getChildrenNode(node, resolve);
      }
      if (node.level === 2) {
        // 二级节点
        this.getChildrenNode(node, resolve);
      }
      if (node.level === 3) {
        // 二级节点
        this.getChildrenNode(node, resolve);
      }
      if (node.level === 4) {
        // 二级节点
        this.getChildrenNode(node, resolve);
      }
    },
    /* async handleNodeClick(data) {
      if (data.level == "3") {
        this.isShowTree = false;
      }
      let res = await api.getImgFromLibrary({ fileId: data.fileId });
      if (res.code == 200) {
        this.imgList = res.data;
      }
    }, */
    async handleNodeClick(data) {
      console.log(data);
      if (data.level == '3') {
        this.isShowTree = false;
      }
      const res = await api.getImgFromLibrary({ fileId: data.fileId });
      console.log(res);
      if (res.code == 200) {
        this.imgList = res.data;
      }
    },
    /* //从图库获取图片
    selectImgFromLibray(item) {
      let index =
        this.imgType == 0
          ? this.imageUrlsExist.indexOf(item.imgAbsolutePath)
          : this.detailImageUrlsExist.indexOf(item.imgAbsolutePath);
      let imgStoreIndex =
        this.imgType == 0
          ? this.mainImgList.indexOf(item.imgAbsolutePath)
          : this.detailImgList.indexOf(item.imgAbsolutePath);
      if (index != -1) {
        this.imgType == 0
          ? this.imageUrlsExist.splice(index, 1)
          : this.detailImageUrlsExist.splice(index, 1);
      } else {
        this.imgType == 0
          ? this.imageUrlsExist.push(item.imgAbsolutePath)
          : this.detailImageUrlsExist.push(item.imgAbsolutePath);
        //  this.imgType==0?this.mainImgList.push(item.imgAbsolutePath):this.fileList2.push(item.imgAbsolutePath);
      }

      if (this.imgType == 0) {
        let length = this.mainImgList.length;
        if (length >= 5) {
          this.$message.warning("主图不能超过5张");
          return false;
        } else {
          if (imgStoreIndex != -1) {
            this.mainImgList.splice(index, 1);
          } else {
            this.mainImgList.push(item.imgAbsolutePath);
          }
        }
      } else {
        let length = this.detailImgList.length;
        if (length >= 10) {
          this.$message.warning("详情图不能超过10张");
          return false;
        } else {
          if (imgStoreIndex != -1) {
            this.detailImgList.splice(index, 1);
          } else {
            this.detailImgList.push(item.imgAbsolutePath);
          }
        }
      }
      console.log(this.imageUrlsExist);
      console.log(this.detailImageUrlsExist);
    }, */
    // 从图库获取图片
    selectImgFromLibray(item) {
      const index =
        this.imgType == 0
          ? this.imageUrlsExist.indexOf(item.imgAbsolutePath)
          : this.detailImageUrlsExist.indexOf(item.imgAbsolutePath);
      const imgStoreIndex =
        this.imgType == 0
          ? productUtils.getIndexInArr(
              this.mainImgList,
              'url',
              item.imgAbsolutePath
            )
          : productUtils.getIndexInArr(
              this.detailImgList,
              'url',
              item.imgAbsolutePath
            );

      if (this.imgType == 0) {
        const { length } = this.mainImgList;
        if (length >= 5) {
          this.$message.warning('主图不能超过5张');
          return false;
        }
        if (index == -1) {
          this.imgType == 0
            ? this.imageUrlsExist.push(item.imgAbsolutePath)
            : this.detailImageUrlsExist.push(item.imgAbsolutePath);
        }
        if (imgStoreIndex == -1) {
          this.mainImgList.push({
            url: item.imgAbsolutePath,
            type: 'warehouse',
          });
          this.mainImgLimit -= 1;
          this.defaultImgList.shift();
        }
      } else {
        const { length } = this.detailImgList;
        if (length >= 10) {
          this.$message.warning('介绍图图不能超过10张');
          return false;
        }
        if (index == -1) {
          this.imgType == 0
            ? this.imageUrlsExist.push(item.imgAbsolutePath)
            : this.detailImageUrlsExist.push(item.imgAbsolutePath);
        }
        if (imgStoreIndex == -1) {
          this.detailImgList.push({
            url: item.imgAbsolutePath,
            type: 'warehouse',
          });
          this.detailImgLimit -= 1;
          this.defaultDetailImgList.shift();
        }
      }
      console.log(this.mainImgList);
      console.log(this.imageUrlsExist);
    },
    nextStep() {
      /* if (this.imageUrlsExist.length === 0 && this.fileList.length === 0) {
        this.$message.warning("请上传图片或者图库图片");
        return;
      } */
      if (this.mainImgList.length == 0) {
        this.$message.warning(
          '您需要先上传图片或在图库中选择图片，再进行下一步操作'
        );
        return;
      }
      if (this.mainImgList.length > 5) {
        this.$message.warning('主图的图片数量不能超过5张');
        return;
      }
      // this.imgType = 1;
      // let params = {
      //   fileType: this.imgType,
      //   parentId: -1
      // };
      // this.imgList = [];
      // this.getImgTreeFromLibrary(params);
      // this.showBtn = false;
      // this.isShowTree = false;
      this.imgType = 1;
      this.imgList = [];
      this.showTree();
      this.showBtn = false;
      this.isShowTree = false;
    },
    preStep() {
      this.showBtn = true;
      this.isShowTree = false;
      this.imgList = [];
      this.imgType = 0;
      const params = {
        fileType: this.imgType,
        parentId: -1,
      };
      this.getImgTreeFromLibrary(params);
    },

    /* //删除主图图片
    deleteMainImgList(url) {
      let index = this.mainImgList.indexOf(url);
      this.mainImgList.splice(index, 1);
      let fileListIndex = this.fileList.indexOf(url);
      if (fileListIndex != -1) {
        this.fileList.splice(fileListIndex, 1);
      }
    }, */
    // 删除主图图片
    deleteMainImgList(item) {
      const index = productUtils.getIndexInArr(
        this.mainImgList,
        'url',
        item.url
      );
      this.mainImgList.splice(index, 1);
      if (item.type === 'warehouse') {
        this.mainImgLimit += 1;
      }
      const fileListIndex = this.fileList.indexOf(item.url);
      if (fileListIndex != -1) {
        this.fileList.splice(fileListIndex, 1);
      }
      const imageIndex = this.imageUrlsExist.indexOf(item.url);
      this.imageUrlsExist.splice(imageIndex, 1);
      this.defaultImgList.unshift(this.mainImgList.length + 1);
    },
    /* //删除详情图图片
    deleteDetailImgList(url) {
      let index = this.detailImgList.indexOf(url);
      this.detailImgList.splice(index, 1);
      let detailFileIndex = this.detailFileList.indexOf(url);
      if (detailFileIndex != -1) {
        this.detailFileList.splice(detailFileIndex, 1);
      }
    }, */
    // 删除详情图图片
    deleteDetailImgList(item) {
      const index = productUtils.getIndexInArr(
        this.detailImgList,
        'url',
        item.url
      );
      this.detailImgList.splice(index, 1);
      if (item.type === 'warehouse') {
        this.detailImgLimit += 1;
      }
      const detailFileIndex = this.detailFileList.indexOf(item.url);
      if (detailFileIndex != -1) {
        this.detailFileList.splice(detailFileIndex, 1);
      }
      const imageIndex = this.detailImageUrlsExist.indexOf(item.url);
      this.detailImageUrlsExist.splice(imageIndex, 1);
      this.defaultDetailImgList.unshift(this.detailImgList.length + 1);
    },

    submitProductImg() {
      /* if (this.imageUrlsExist.length == 0 && this.fileList.length == 0) {
        this.$message.warning("请添加商品主图");
        return;
      }
      if (this.detailImageUrlsExist.length == 0 && this.detailFileList.length == 0) {
        this.$message.warning("请添加商品详情图");
        return;
      }
      if (this.detailImgList.length > 10) {
        this.$message.warning("介绍图不能超过10张");
        return;
      } */

      if (this.imageUrlsExist.length == 0 && this.fileList.length == 0) {
        this.$message.warning('请添加商品主图');
        return;
      }
      if (
        this.detailImageUrlsExist.length == 0 &&
        this.detailFileList.length == 0
      ) {
        this.$message.warning('请添加商品介绍图');
        return;
      }
      if (this.detailImgList.length > 10) {
        this.$message.warning('介绍图的图片数量不能超过10张');
        return;
      }
      const params = {
        imageUrls: this.fileList, // 主图上传
        detailImageUrls: this.detailFileList, // 详情图上传
        imageUrlsExist: this.imageUrlsExist, // 主图图库
        detailImageUrlsExist: this.detailImageUrlsExist, // 详情图图库
      };

      this.associatedImagesVisible = false;
      this.$refs.mainImg?.clearFiles();
      this.$refs.detailImg?.clearFiles();
      this.showBtn = true;
      this.fileList1 = [];
      this.fileList2 = [];
      console.log(params);

      this.$emit('getAllImageUrls', params);
    },
    async showTree() {
      const params = {
        fileType: this.imgType,
        parentId: -1,
      };
      await this.getImgTreeFromLibrary(params);
      this.isShowTree = true;
    },
    // 二级节点
    async getChildrenNode(node, resolve) {
      console.log(node);
      const { fileId } = node.data;

      const res = await api.getImgTreeFromLibrary({
        fileType: this.imgType,
        parentId: fileId,
      });
      if (res.code == 200) {
        console.log(res);
        this.childrenList = res.data;
        resolve(this.childrenList);
      }
    },
    async getImgTreeFromLibrary(params) {
      const res = await api.getImgTreeFromLibrary(params);
      if (res.code == 200) {
        this.treeData = res.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
@import '@/assets/css/theme.scss';
.img_dialog {
  .img-choice {
    p {
      color: #999;
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 20px;
    height: 679px;
  }
}

.contents {
  min-height: 500px;
  width: auto;
  // min-height: 500px;
  //   padding: 10px;
  /* overflow-y: scroll; */
  box-sizing: border-box;
  .img-store-wrap {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    border-bottom: 1px solid #d9d9d9;
  }
  .img-ope {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    // margin-top: 20px;
    width: 186px;
    .ope {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      .img-tree {
        // position: absolute;
        // top: 34px;
        // left: 0px;
        // z-index: 1000;
        border: 1px solid #ddd;
        width: 100%;
        height: 300px;
        background: #fff;
        overflow-y: auto;
      }
      .img-tree-wrap {
        border: 1px solid #d9d9d9;
        width: 187px;
        height: 30px;
        display: inline-block;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333;
        padding-left: 10px;
        cursor: pointer;
      }
    }
  }
  .img-list {
    margin-top: 20px;
    height: 320px;
    overflow-y: auto;
    width: 560px;
    display: flex;
    margin-left: 20px;
    flex-wrap: wrap;
    // border-bottom: 1px solid #d9d9d9;
    // &:after {
    //   display: inline-block;
    //   width: 100%;
    //   content: "";
    // }
    div {
      position: relative;
      &:not(:nth-child(5n)) {
        margin-right: 10px;
      }
    }
    img {
      width: 100px;
      height: 100px;
      cursor: pointer;
      // margin-right: 10px;
    }
    span {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 2px solid #c5c5c5;
      position: absolute;
      top: 4px;
      right: 14px;
      color: #fff;
      font-weight: 800;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        background: $main-col;
        border: 1px solid $main-col;
      }
    }
  }
  .choice-img-wrap {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    &.detail-img-wrap {
      overflow-x: scroll;
      width: 100%;
      height: 115px;
    }
    & > div {
      display: flex;
      position: relative;
      // margin-left: 10px;
    }
    img {
      width: 100px;
      height: 100px;
    }
    .icon-close {
      position: absolute;
      // right: 6px;
      // top: 6px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    .default-img-wrap {
      position: absolute;
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #d9d9d9;
      // margin-left: 20px;
      img {
        width: 40px;
        height: 28px;
      }
    }
    .images {
      background: #fff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      height: 100px;
      .icon-close {
        display: none;
      }
      .mask {
        width: 100px;
        height: 100px;
        position: absolute;
        z-index: 1;
        background: rgba(0, 0, 0, 0.5);
        display: none;
      }
      &:hover {
        // background: rgba(0, 0, 0, 0.5);
        //  width: 100px;
        //  height: 100px;
        //  position: absolute;
        //  z-index: 1000;
        .mask {
          display: inline-block;
        }
        .icon-close {
          display: inline-block;
          width: 16px;
          height: 16px;
          position: absolute;
          z-index: 2;
        }
      }
      .main-img-icon-wrap {
        position: absolute;
        width: 100px;
        height: 20px;
        left: 0px;
        top: 0px;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        .icon-main {
          width: 6px;
          height: 6px;
          margin-right: 4px;
        }
        span {
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
  .img-local {
    padding-top: 10px;
    display: flex;
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 10px;
    // border-top: 1px solid #ddd;
    .img-item {
      // width: 148px;
      display: flex;
      flex-flow: column;
      .txt {
        // width: 100px;
        // height: 24px;
        // border-left: 1px solid #d9d9d9;
        // border-right: 1px solid #d9d9d9;
        // border-bottom: 1px solid #d9d9d9;
        // text-align: center;
        line-height: 24px;
        font-size: 14px;
        color: #999;
      }
    }
    .upload-txt {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
    .upload-btn {
      width: 100px;
      height: 100px;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      img {
        width: 36px;
        height: 36px;
      }
    }
  }
  .btn-wrap {
    text-align: center;
    margin-top: 20px;
  }
}

.img_dialog ::v-deep .el-dialog__header {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  background: #f5f5f5;
  padding: 8px;
  // /* padding-bottom: 10px;
}
.img_dialog ::v-deep .el-dialog__title {
  font-size: 14px;
  color: #333;
}
.img_dialog ::v-deep .el-dialog__headerbtn {
  top: 10px;
}
.img_dialog ::v-deep .el-dialog__body {
  padding: 20px;
  max-height: 679px !important;
}
</style>
